import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@/../environments/environment';
import { IAppConfig } from '@/shared/models';
import { NGXLogger } from 'ngx-logger';

// Check https://robinraju.dev/developer/2017-11-14-loading-external-config-in-angular/

@Injectable()
export class AppConfig {
    appConfig: IAppConfig; // Can be made private to enforce use of getters below!
    private loadServerConfig = false;

    constructor(private http: HttpClient, private logger: NGXLogger) {}

    async loadAppConfig() {
        // By Default, we use the static environment file as the config.
        this.appConfig = environment as IAppConfig;
        if (this.loadServerConfig) {
            // Adding the inital dot (./assets/config.json) ensures that base-href is used
            const configFile = './assets/config.json'; // './assets/config.${environment.name}.json'
            try {
                const data = await this.http.get(configFile).toPromise();
                this.appConfig = data as IAppConfig;
            } catch (reason) {
                this.logger.debug('Not Found Config JSON, Using Defaults...');
            }
        }
    }

    get apiUrl() {
        if (!this.appConfig) {
            throw Error('Config file not loaded!');
        }
        const base = this.appConfig.apiBase;
        const apiUrl = base.startsWith('http') ? base : location.origin + base;
        return apiUrl; // this.appConfig.apiUrl;
    }

    get aiApiUrl() {
        if (!this.appConfig) {
            throw Error('Config file not loaded!');
        }

        return this.appConfig.aiApiBase;
    }

    get templateUrl() {
        return location.origin;
    }

    get title() {
        return this.appConfig.title;
    }

    get loginTitle() {
        return this.appConfig.loginTitle;
    }

    get logLevel() {
        return this.appConfig.logLevel;
    }

    get serverLogLevel() {
        return this.appConfig.serverLogLevel;
    }

    get serverLogUrl() {
        return this.appConfig.serverLogUrl;
    }
    get routeTracing() {
        return this.appConfig.routeTracing;
    }
    get googleMapsAPIKey() {
        return this.appConfig.googleMapsAPIKey;
    }

    get vapidKey() {
        return this.appConfig.vapidKey;
    }
}
